import { CodeIcon, SlidersHorizontalIcon } from "lucide-react";

import { BasicTooltip } from "../../code-editor/BasicTooltip";

import { OpenaiYamlPreviewMode } from "./openai-yaml-preview-mode";

export interface OpenaiYamlHeaderToggleButtonProps {
  mode: OpenaiYamlPreviewMode;
  onToggle: () => void;
}

export const OpenaiYamlHeaderToggleButton = ({ mode, onToggle }: OpenaiYamlHeaderToggleButtonProps) => (
  <BasicTooltip
    content={
      mode === OpenaiYamlPreviewMode.Form ? "Switch to raw YAML" : "Switch to overview"
    }
  >
    <button
      type="button"
      className="flex items-center justify-center rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
      onClick={onToggle}
    >
      {mode === OpenaiYamlPreviewMode.Form ? (
        <CodeIcon className="h-4 w-4" />
      ) : (
        <SlidersHorizontalIcon className="h-4 w-4" />
      )}
    </button>
  </BasicTooltip>
);
